export class MemberPassword {
    password: string;
    confirmPassword: string;
    oldPassword: string;

    constructor(member) {
        this.password = member.password || '';
        this.confirmPassword = '';
        this.oldPassword = member.oldPassword || '';
    }
}
